<div class="section" [class.dark]="dark" [class.black]="black">
  <div class="page">
    <div class="footer-menu">
      <a class="footer-logo" *onlyForScreens="['desktop']" [routerLink]="['/']">
        <img src="/assets/picflow-icon-black.svg" alt="" width="42" height="42" loading="lazy" *ngIf="!dark" />
        <img src="/assets/picflow-icon-white.svg" alt="" width="42" height="42" loading="lazy" *ngIf="dark" />
      </a>
      <div class="footer-menu-list">
        <div class="footer-menu-list-title">Picflow</div>
        <a [routerLink]="'/auth/signup'" class="footer-list-item">Try for Free</a>
        <a [routerLink]="'/pricing'" class="footer-list-item">Pricing</a>
        <a [routerLink]="'/showcase'" class="footer-list-item">Showcase</a>
      </div>
      <div class="footer-menu-list">
        <div class="footer-menu-list-title">Features</div>
        <a [routerLink]="'/gallery-designer'" class="footer-list-item">Gallery Designer</a>
        <a [routerLink]="'/review-and-approvals'" class="footer-list-item">Review & Approvals</a>
        <a [routerLink]="'/advanced-mode'" class="footer-list-item">Workflow</a>
      </div>
      <div class="footer-menu-list">
        <div class="footer-menu-list-title">Explore</div>
        <a [routerLink]="'/feature-index'" class="footer-list-item">Feature Index</a>
        <a class="footer-list-item" [routerLink]="'/learn'">Learn Picflow</a>
        <a class="footer-list-item" [routerLink]="'/compare'">Compare</a>
        <a class="footer-list-item" [routerLink]="'/image-converter'">Image Converter</a>
        <!-- <a class="footer-list-item" [routerLink]="'/affiliates'">Affiliates</a> -->
      </div>
      <div class="footer-menu-list">
        <div class="footer-menu-list-title">Community</div>
        <a href="https://help.picflow.com" class="footer-list-item" rel="noopener" target="_blank"
          >Knowledge Base <app-svg src="/assets/icons/16/arrow-external.svg"></app-svg
        ></a>
        <a href="https://feedback.picflow.com/features" rel="noopener" target="_blank" class="footer-list-item"
          >Feature Requests <app-svg src="/assets/icons/16/arrow-external.svg"></app-svg
        ></a>
        <a [routerLink]="'/press'" class="footer-list-item" rel="noopener">Press & Media </a>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="badges">
        <div class="badge">
          <img src="/assets/icons/special/switzerland.svg" loading="lazy" width="32" height="32" alt="" />
          <div class="badge-content">Made in Switzerland</div>
        </div>
        <div class="badge">
          <img src="/assets/icons/special/eu.svg" loading="lazy" width="32" height="32" alt="" />
          <div class="badge-content">GDPR Compliant</div>
        </div>
      </div>

      <div class="footer-bottom-menu">
        <div class="footer-bottom-part">
          <span class="copyright">© {{ currentYear }} Nusign AG</span>
          <a
            href="https://help.picflow.com/en/articles/5538118-privacy-policy"
            class="footer-bottom-menu-item"
            target="_blank"
            >Privacy</a
          >
          <a
            href="https://help.picflow.com/en/articles/5538133-terms-of-service"
            class="footer-bottom-menu-item"
            target="_blank"
            >Terms</a
          >
          <a
            href="https://help.picflow.com/en/articles/5540754-security-standards"
            class="footer-bottom-menu-item"
            target="_blank"
            >Security</a
          >
        </div>

        <div class="spacer"></div>

        <div class="footer-bottom-part">
          <a
            href="https://www.instagram.com/picflow/"
            target="_blank"
            appButton
            name="instagram"
            location="website-footer"
            [iconButton]="true"
            height="0"
            color="hard-simple"
            class="social-icon"
          >
            <app-svg src="/assets/icons/logo/instagram.svg"></app-svg>
          </a>
          <a
            href="https://twitter.com/PicflowHQ"
            target="_blank"
            appButton
            name="twitter"
            location="website-footer"
            [iconButton]="true"
            height="0"
            color="hard-simple"
            class="social-icon"
          >
            <app-svg src="/assets/icons/logo/twitter.svg"></app-svg>
          </a>
          <a
            href="https://www.linkedin.com/company/picflow/"
            target="_blank"
            appButton
            name="linkedin"
            location="website-footer"
            [iconButton]="true"
            height="0"
            color="hard-simple"
            class="social-icon"
          >
            <app-svg src="/assets/icons/logo/linkedin.svg"></app-svg>
          </a>
          <a
            href="https://www.youtube.com/@Picflow"
            target="_blank"
            appButton
            name="youtube"
            location="website-footer"
            [iconButton]="true"
            height="0"
            color="hard-simple"
            class="social-icon"
          >
            <app-svg src="/assets/icons/logo/youtube.svg"></app-svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
